<template>
  <div class="box">
    <!-- 顶部图片 -->
    <div class="topBg"></div>
    <!-- tabs切换 -->
    <van-tabs sticky @change="CateIdClick">
      <van-tab name="全部" title="全部"> </van-tab>
      <van-tab v-for="item in allListType" :key="item.id" :name="item.id" :title="item.typeName" >
      </van-tab>
    </van-tabs>
    <!-- 列表 -->
    <!-- 没有更多了 -->
    <van-list :loading="loading" :finished="finished" finished-text="没有更多了"     offset="50" :immediate-check="false"
      @load="onLoad">
      <div class="lists">
        <div class="list" v-for="item in list" :key="item.id" @click="gotoUrl('/guanghe/index/' + item.LeaseId)">
          <div style="display: flex; border-bottom: 1px solid #f4f4f4">
            <div class="listImg">
              <img v-if="item.Imgs != null && item.Imgs != ''" :src="item.Imgs.split(',')[0]"
                style="width: 100%; height: 100%; border-radius: 4px" />
              <img v-else src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/16b3.png"
                style="width: 100%; height: 100%; border-radius: 4px" />
            </div>
            <div class="listTitle">
              <!-- <span style="height: 44%">{{ item.RoomSource }}</span> -->
              <div style="height: 26%" class="userinfo_title">{{ item.title }}</div>
              <div class="userinfo">
                <div class="userinfo_TouchMan">
                  <div class="image"><img src="../../../public/oldManBill/people.png" alt=""></div>
                  <div>{{ item.TouchMan }}</div>
                </div>
                <div class="userinfo_TouchTel">
                  <div class="image"><img src="../../../public/oldManBill/phone.png" alt=""></div>
                  <div>{{ item.TouchTel }}</div>
                </div>
              </div>
              <div class="userinfo_Address">
                <div class="image">
                  <img src="../../../public/oldManBill/address.png" alt="">
                </div>
                <div class="userinfo_address"> {{ item.Address }}</div>
              </div>
              <div>

              </div>
              <div class="listLabel">
                <!-- <div
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                "
              >
               {{ item.Address }}
              </div> -->
                <div class="money">
                  {{ Number(item.Price) }}
                  <i style="color: #fc4839; font-size: 13px; font-style: normal">元/月</i>
                </div>
                <div class="yamoney">
                  押金方式: {{ item.Deposit }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <!-- 购物车 -->
    <!-- <div class="shopping" @click="shoppingClick()" v-if="shoppongShow">
      <img
        src="../../assets/shop/shopping.png"
        alt=""
        style="width: 60%; margin: 12px 17%"
      />
    </div> -->
    <div>
      <van-popup v-model="shoppingShow" round position="bottom" :style="{ height: '70%' }">
        <!-- 商品列表 -->
        <div class="goodsLists">
          <div class="goodsList" v-for="item in shoppingList" :key="item.GoodsId">
            <div style="width: 32%">
              <img :src="item.GoodsImg" style="width: 110px; height: 100px; margin: 10px" />
            </div>
            <div style="width: 65%">
              <div class="flex">
                <span style="color: #01a0fb; font-weight: 700">{{ item.GoodsName }}</span>
                <span>{{ item.Price }}/{{ item.MUnit }}</span>
              </div>
              <div class="flex">
                <span style="color: #ee0c24">¥{{ item.Amount }}</span>
                <span>
                  <van-stepper v-model="item.GoodsNum" theme="round" min="0" button-size="22" disable-input
                    @change="Goodschange(item)" style="display: inline-block" />
                </span>
              </div>
              <div class="flex">
                <button @click="goodsDelete(item.OGoodsId)" class="delete">
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 结算按钮 -->
        <div class="button">
          <button @click="orderClick()">结 算</button>
        </div>
      </van-popup>
    </div>
    <!-- 收货地址 -->
    <van-popup v-model="addressShow" round position="bottom" :style="{ height: '70%' }">
      <div class="address">
        <van-radio-group v-model="checked">
          <van-radio name="0">
            <div>
              <div class="radioBox">
                <span>自提</span>
              </div>
            </div>
          </van-radio>
          <van-radio :name="item.BindId" v-for="item in addressList" :key="item.BindId">
            <div>
              <div class="radioBox">
                <span>收件人:{{ item.Name }}</span><span>联系电话:{{ item.Mobile }}</span>
              </div>
              <div style="font-size: 14px; padding-top: 5px">地址:{{ item.Addr }}</div>
            </div>
          </van-radio>
        </van-radio-group>
      </div>
      <div class="button">
        <button @click="PlaceOrder">支 付</button>
      </div>
      <div class="integralBox">
        <van-radio-group v-model="integralCk" direction="horizontal">
          <van-radio name="1">会员积分({{ CurIntegral }}分)</van-radio>
          <van-radio name="2">党员积分({{ PmCurIntegral }}分)</van-radio>
          <van-radio name="3">志愿者积分({{ VolCurIntegral }}分)</van-radio>
        </van-radio-group>
      </div>
    </van-popup>

    <!-- 发布按钮小按钮 -->
    <div class="backTop" @click="gotoUrl('/guanghe/addXianzhi')">
      <!-- v-if="isWorkMan == 1" -->

      <img class="top_iamge" src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png" alt="" />
    </div>
  </div>
</template>
<script>
import { WeMyMemberInfo, WxGetLeasePage, listType, getType } from '@/api/RealInfo'
import {
  WeGenerateOrder,
  WeGetMyOrderPage,
  WeGetOrderGoodsList,
  WePlaceOrder,
  WeDeleteOrderGoods,
  WeSaveOrderService,
  WeGetMyBindInfoPage,
} from '@/api/shop'
import { getOpenId, setOpenId } from '@/utils/auth'
import Vue from 'vue'
import { Toast } from 'vant'
import { Dialog } from 'vant'
Vue.use(Toast)
Vue.use(Dialog)
export default {
  data() {
    return {
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      // 分页需要的参数
      listfrom: {
        // typeId:0,
        page: 1,
        limit: 10,
        // pAKind: 1,
      },
      infoId: this.$route.params.id,
      shopType: '', //商铺类型
      type: "全部", //tabs选中
      tabList: [], //tabs类型
      list: [
        {
          Logo: 'https://dximg.dexian.ren/111.png',
          Name: '九鼎中和湾三室精装 周边配套完善观河景 环境舒适 地铁口',
          WorkTime: '2室·93.13m²·九鼎中和湾·古城路',
          Address: '1700',
        },
      ], //商品列表
      integralNum: 0,
      shoppingList: [], //购物车列表
      shoppingShow: false, //购物车弹窗
      order: '', //订单
      addressShow: false, //收货地址
      shoppongShow: false, //购物车按钮
      addressList: [], //收货地址
      checked: '0', //收货地址选择
      integralCk: '1', //积分选择
      CurIntegral: '', //会员当前积分
      PmCurIntegral: '', //党员当前积分
      VolCurIntegral: '', //志愿者当前积分（时间币）
      totalNum: 0, //总商品数
      totalGold: 0, //总金额
      // 全部房屋的
      typeId: 0,
      // 所有房屋类型
      allListType: []
    }
  },
  mounted() {
    // setOpenId("oas2d4qNkpHqYBS0NlA4glPsVR1k"); //测试openid
    // this.getTabsList();
    this.getCommNoticeList()
    this.getMemberByOpenID()
    this.getAlllistType()
    // this.getUserOrder();
  },
  methods: {
    // 选择商品
    orderClick() {
      this.addressShow = true
      WeGetMyBindInfoPage({ OpenID: getOpenId() }).then((res) => {
        if (res.data.count == 0) {
          Dialog.confirm({
            title: '提醒',
            message: '您还没有添加收货地址,是否前往添加!',
          })
            .then(() => {
              if (window.__wxjs_environment === 'miniprogram') {
                window.wx.miniProgram.navigateTo({
                  url: "../my/user/oldManList/index?name='收货地址'",
                })
              } else {
                alert('请在小程序中打开')
              }
            })
            .catch(() => {
              return false
            })
        } else {
          this.addressList = res.data.data
        }
      })
    },
    // 步进器选择
    Goodschange(row) {
      WeSaveOrderService({
        //添加订单商品
        OpenID: getOpenId(),
        OrderId: this.order,
        GoodsId: row.GoodsId,
        GoodsNum: row.GoodsNum,
      }).then((res) => {
        Toast(row.GoodsName + ':' + row.GoodsNum)
        this.getshoppingList(this.order)
      })
    },
    // 获取订单情况
    getUserOrder() {
      console.log(this.list)
      return
      WeGetMyOrderPage({ LeaseId: 74, OpenID: getOpenId(), status: 1 }).then((res) => {
        if (res.data.code != 0) {
          Toast.fail(res.data.msg)
          this.shoppongShow = false
        } else {
          if (res.data.count == 0) {
            // 没有订单 生成订单
            WeGenerateOrder({ LeaseId: 74, OpenID: getOpenId() }).then((res) => {
              this.getshoppingList(res.data.data)
              this.order = res.data.data
              this.shoppongShow = true
            })
          } else {
            // 有订单使用现有订单
            this.getshoppingList(res.data.data[0].OrderId)
            this.order = res.data.data[0].OrderId
            this.shoppongShow = true
          }
        }
      })
    },
    // 获取购物车列表
    getshoppingList(row) {
      this.totalNum = 0
      this.totalGold = 0
      WeGetOrderGoodsList({ OpenID: getOpenId(), orderId: row }).then((res) => {
        this.shoppingList = res.data.data
        for (let i = 0; i < this.shoppingList.length; i++) {
          this.totalNum += this.shoppingList[i].GoodsNum
          this.totalGold += this.shoppingList[i].Amount
        }
      })
    },
    // 购物车点击
    shoppingClick() {
      this.shoppingShow = true
      this.getshoppingList(this.order)
    },
    // 切换分类
    CateIdClick(val) {
      console.log(val,"123");
      this.finished = false;
      if (val == "全部") {
        console.log(val, 44444);
        this.listfrom.typeId = null
        this.listfrom.page = 1
        this.list = []
        this.getCommNoticeList();

      } else{
        console.log(val, 5555);
        this.listfrom.page = 1
        this.listfrom.typeId = val
        this.list = []
        this.getCommNoticeList()
      }
    },
    // // 获取所有分类
    getAlllistType() {
      listType().then((res) => {
        this.allListType = res.data.data
        console.log(this.allListType, 1111111111111111);

      })
    },
    // 获取不同分类列表
    getTabsList() {
      console.log(3243454);
      WxGetShopTypeList({ shopCate: 2 }).then((res) => {
        this.tabList = res.data.data;
        console.log(this.tabList, ":this.tabList ");
      });
    },
    // 获取列表 全部和 房屋
    // getList() {
    //   // 获取所有出租分类方式
    //   let listType = listType()
    //   // 查询房源类型详细
    //   // getType(this.listfrom.id)
    //   WxGetLeasePage(this.listfrom).then((res) => {
    //     console.log(res, 11111111111)
    //     this.list = res.data.data
    //     // console.log("this", this.list);
    //     // this.shopType = this.list[0].STypeId;
    //     // console.log(this.shopType, "this.shopType ");
    //   })
    // },
    // 获取会员信息
    getMemberByOpenID() {
      WeMyMemberInfo({ OpenID: getOpenId() }).then((res) => {
        if (res.data.code == 0) {
          var data = res.data.data
          console.log(data, '积分')
          this.integralNum = data.CurIntegral
          this.CurIntegral = data.CurIntegral
          this.PmCurIntegral = data.PmCurIntegral
          this.VolCurIntegral = data.VolCurIntegral
        } else {
          Toast.fail('您还不是会员,请先注册会员!')
        }
      })
    },
    // 下单结算
    PlaceOrder() {
      if (this.checked == 0) {
        var DeliveryMode = 2
        this.checked = undefined
      } else {
        var DeliveryMode = 1
      }
      if (this.totalGold > this.integralNum) {
        Toast.fail('积分不足,无法兑换商品!')
        return false
      }
      WePlaceOrder({
        OpenID: getOpenId(),
        ScoreType: this.integralCk,
        BindId: this.checked,
        DeliveryMode: DeliveryMode,
        OrderId: this.order,
        GoodsScore: this.totalGold,
        // GoodsNum:this.totalNum,
      }).then((res) => {
        if (res.data.code == 0) {
          Toast.success('提交成功!')
          this.addressShow = false
          this.shoppingShow = false
          this.getMemberByOpenID()
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    // 删除单独商品
    goodsDelete(row) {
      WeDeleteOrderGoods({
        OpenID: getOpenId(),
        OrderId: this.order,
        OGoodsId: row,
      }).then((res) => {
        if (res.data.code == 0) {
          this.getshoppingList(this.order)
          this.shoppingShow = false
          Toast.success('删除成功!')
        }
      })
    },
    //跳转到公共页面
    gotoUrl(path) {
      console.log(11111111111111111);
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + path,
        })
      } else {
        this.$router.push(path)
      }
    },
    // 上拉加载需要的函数
    onLoad() {
      console.log("asdsad");
      this.listfrom.page = this.listfrom.page+1 ;
      this.loading = true;
      this.getCommNoticeList();
    },
    // 获取页面
    getCommNoticeList() {
      WxGetLeasePage(this.listfrom).then((res) => {
        this.loading = false;
        console.log(res,1111);
        if (res.data.code == 0) {
          let rows = res.data.data; //请求返回当页的列表
          // 加载状态结束

          if (rows == null || rows.length === 0) {
            // 加载结束
            console.log("结束");
            this.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          this.list = this.list.concat(rows);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list.length >= res.data.count) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
  },
}
</script>
<style scoped>
.box {
  background: #fff;
  /* height: 100%; */
  min-height: 100vh;
}

/* 背景 */
.topBg {
  position: relative;
  margin: auto;
  height: 90px;
  width: 92%;
  background: url('https://dximg.dexian.ren/banner.png') no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 10px;
}

/* 列表 */
.lists {
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
}

.lists .list {
  width: 92%;
  margin: auto;
}

.lists .listImg {
  width: 31.5%;
  height: 85px;
  text-align: center;
  margin: 10px 3% 16px;
}

.listTitle {
  flex: 1;
  margin: 12px 0;
}

.listTitle span:nth-child(1) {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #231815;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.listLabel div:nth-child(1) {
  /* margin-bottom: 1px; */
}

.listLabel {
  display: flex;
  margin-top: 6px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  align-items: center;
  /* justify-content: space-between; */
}

.money {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fc4839;
  width: 50%;
}

.yamoney {
  color: #999;

}

/* 购物车 */
.shopping {
  position: fixed;
  right: 15px;
  bottom: 25px;
  width: 65px;
  height: 65px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 4px #f5eeee;
}

.goodsLists {
  width: 95%;
  margin: 10px auto 10px;
  background: #fff;
  height: 57vh;
  border-radius: 10px;
  overflow-y: scroll;
}

.goodsList {
  display: flex;
  justify-items: center;
  /* align-items: center; */
  background: #fff;
  border-radius: 10px;
  margin-bottom: 7px;
}

.button {
  width: 100%;
  text-align: center;
}

.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
}

.button button {
  position: fixed;
  bottom: 15px;
  width: 80%;
  height: 40px;
  line-height: 40px;
  background: #01a0fb;
  color: #fff;
  border: none;
  margin: 8px auto 15px;
  border-radius: 6px;
  left: 10%;
}

.goodsList .delete {
  background: #ee0c24;
  border: none;
  color: #fff;
  font-size: 14px;
  border-radius: 7px;
  padding: 5px 13px;
}

.address .van-radio {
  background: #f5f5f5;
  width: 80%;
  margin: 10px auto;
  padding: 6px 15px;
  border-radius: 6px;
}

.address .radioBox {
  display: flex;
  justify-content: space-between;
  width: 70vw;
  font-size: 14px;
}

.integralBox {
  position: absolute;
  bottom: 81px;
  font-size: 12px;
  margin-left: 10%;
}


/* 发布小按钮 */
.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.userinfo {
  display: flex;
  justify-content: space-between;
  color: #999999;
  font-size: 14px;
  margin: 5px 0;
}

.userinfo_TouchMan,
.userinfo_TouchTel {
  width: 50%;
  display: flex;
  align-items: center;

}

.userinfo .image {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.userinfo_Address .image {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.userinfo img {
  width: 100%;
}

.userinfo_Address {
  display: flex;
  color: #999999;
  font-size: 14px;
}

.userinfo_Address img {
  width: 100%;
}

.userinfo_title {
  font-size: 20px;
}
</style>
